<template>
  <div class="home-tiles-menu tiles-grid">
    <router-link :to="{ name: 'connect-internet' }" class="tile-link">
      <home-tiles-menu-item title="Підключити інтернет" :image="menuImage1" />
    </router-link>
    <router-link :to="{ name: 'refer-friend' }" class="tile-link">
      <home-tiles-menu-item title="Приведи друга" :image="menuImage2" />
    </router-link>
    <div class="tile-link" @click="openPromotions" role="button">
      <home-tiles-menu-item title="Акції" :image="menuImage3" />
    </div>
    <div
      v-if="hasAvailableCategories"
      class="tile-link"
      @click="openShop"
      role="button"
    >
      <home-tiles-menu-item title="Магазин" :image="menuImage4" />
    </div>
    <a href="https://t.me/crystalsend_bot" target="_blank" class="tile-link">
      <home-tiles-menu-item title="Підтримка" :image="menuImage5" />
    </a>
  </div>
</template>

<script>
import { computed } from "vue";
import { useStore } from "vuex";
import HomeTilesMenuItem from "@/components/home/HomeTilesMenuItem.vue";
import menuImage1 from "@/assets/home/img-internet.jpg";
import menuImage2 from "@/assets/home/img-invite-friend.jpg";
import menuImage3 from "@/assets/home/img-stock.jpg";
import menuImage4 from "@/assets/home/img-shop.jpg";
import menuImage5 from "@/assets/home/img-technical-support.jpg";
import { eventBus, events } from "@/eventBus";

export default {
  name: "HomeTilesMenu",
  components: {
    HomeTilesMenuItem,
  },
  setup() {
    const store = useStore();

    const hasAvailableCategories = computed(() => {
      return store.getters["shop/availableCategories"].length > 0;
    });

    const openPromotions = () => {
      eventBus.$emit(events.OPEN_SHEET_PROMOTION);
    };

    const openShop = () => {
      eventBus.$emit(events.OPEN_SHEET_SHOP);
    };

    return {
      menuImage1,
      menuImage2,
      menuImage3,
      menuImage4,
      menuImage5,
      hasAvailableCategories,
      openPromotions,
      openShop,
    };
  },
};
</script>

<style scoped lang="less">
@import "@/styles/_variables.less";

.home-tiles-menu {
  &.tiles-grid {
    display: grid;
    gap: 20px;
    grid-template-columns: repeat(1, 1fr);

    @media (min-width: 320px) {
      grid-template-columns: repeat(2, 1fr);
    }

    @media @md {
      gap: 25px;
      grid-template-columns: repeat(3, 1fr);
    }

    @media @lg {
      gap: 30px;
      grid-template-columns: repeat(4, 1fr);
    }

    @media @xl {
      grid-template-columns: repeat(5, 1fr);
    }
  }

  .tile-link {
    display: block;
    width: 100%;
    height: 100%;
    text-decoration: none;
  }
}
</style>
